export function getMicrophoneErrorMessage(
  error: unknown,
  t: (key: string, options?: { message?: string }) => string,
): string {
  if (error instanceof DOMException) {
    if (error.name === "NotAllowedError") {
      return t("transcription.micErrors.notAllowed");
    }
    if (error.name === "NotFoundError") {
      return t("transcription.micErrors.notFound");
    }
    if (error.name === "NotReadableError") {
      return t("transcription.micErrors.notReadable");
    }
  }
  const message = error instanceof Error ? error.message : String(error);
  return t("transcription.micErrors.generic", { message });
}

export const DEFAULT_AUDIO_CONSTRAINTS: MediaTrackConstraints = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};
